exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-navigation-drawer--mini-variant .logout {\r\n  display: none;\n}\n.cashier {\r\n  height: 100%;\r\n  position: fixed;\r\n  width: 0%;\r\n  z-index: 500;\r\n  right: 0;\r\n  transition: width 0.1s;\n}\n.cashier.cashier-active {\r\n  height: 100%;\r\n  position: fixed;\r\n  width: 90%;\r\n  z-index: 500;\r\n  right: 0;\r\n  padding: 16px;\n}\r\n", ""]);

// exports
